import { InfoBar } from "@/components/alerts/InfoBar/InfoBar";
import { InfoBarBackgroundThemeEnum, InfoBarTextThemeEnum } from "@/common/api/services/types";
import "./AvSignupInfoBar.scss";

interface AvSignupInfoBarProps {
  text: string;
  ctaText: string;
  ctaLink: string;
  onLinkAction: (id: string) => void;
  onCloseInfoBar: (id: string) => void;
}

export const AvSignupInfoBar = ({ text, ctaText, ctaLink, onLinkAction, onCloseInfoBar }: AvSignupInfoBarProps) => {
  return (
    <div className="AvSignupInfoBar">
      <InfoBar
        onLinkAction={onLinkAction}
        onCloseInfoBar={onCloseInfoBar}
        notification={{
          id: "av-signup-prompt",
          text,
          cta_text: ctaText,
          cta_link: ctaLink,
          type: "",
          background_theme: InfoBarBackgroundThemeEnum.standard,
          text_theme: InfoBarTextThemeEnum.light,
          close_button_enabled: 1,
        }}
        showNotify={true}
        preventNavigation={true}
      />
    </div>
  );
};
